import { render, staticRenderFns } from "./ChangeRateModal.vue?vue&type=template&id=7163f653&scoped=true&"
import script from "./ChangeRateModal.vue?vue&type=script&lang=js&"
export * from "./ChangeRateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7163f653",
  null
  
)

export default component.exports